import crypto from 'crypto'



export const regexLink = (value) => {
  if(value.split("youtu.be/")[1]){
    let updateValue = value.split("youtu.be/")[1];
    let ampersandPosition = updateValue.indexOf("&");
    if (ampersandPosition !== -1) {
      updateValue = updateValue.substring(0, ampersandPosition);
    }
    return updateValue;
  }else{
    return "abc"
  }
};




export const parseCookies = (cookie = "") => {
  return cookie
    .split(";")
    .map((v) => v.split("="))
    .map(([k, ...vs]) => [k, vs.join("=")])
    .reduce((acc, [k, v]) => {
      acc[k.trim()] = decodeURIComponent(v);
      return acc;
    }, {});
};

export const generateSession = () => {
  return new Promise((resolve, reject) => {
    crypto.randomBytes(256, function (err, buffer) {
      return resolve(buffer.toString("base64"));
    });
  });
};

export const generateEndTime = () => {
  const today = new Date();
  const expirationTime = today.setDate(today.getDate() + 7);
  return new Date(expirationTime);
};

export const delete_cookie= (name, path, domain) =>{
    document.cookie =
      name +
      "=" +
      (path ? ";path=" + path : "/") +
      // (domain ? ";domain=" + domain : "") +
      `${new Date()}`;
}

export const getCookie = (name) =>{
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

export function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + new Date();
  } else {
    var expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

